import { MILLISECONDS } from '@chiroup/core/constants/time';
import { Muscle } from '@chiroup/core/types/Muscle.type';
import { use } from 'react';
import { useQuery } from 'react-query';
import { MeContext } from '../contexts/me.context';
import { useSandboxClinicalData } from '../contexts/sandboxClinicalData.context';
import muscleService from '../services/muscle.service';

type Props = {
  refetchOnMount?: boolean;
};

const useMuscles = ({ refetchOnMount = true }: Props = {}) => {
  const sandbox = useSandboxClinicalData();
  const meContext = use(MeContext);
  const { data, isFetching } = useQuery<{
    data: Muscle[];
  }>(
    'muscle',
    () =>
      sandbox
        ? { data: sandbox.muscles }
        : muscleService.list(meContext.me.selectedClinic?.ID || -1),
    {
      refetchOnWindowFocus: false,
      refetchOnMount,
      staleTime: MILLISECONDS.inHours(2),
    }
  );

  return { data, isFetching };
};

export default useMuscles;
